<template>
  <authenticated> 
    <v-tabs grow v-model="activeTab">
      <v-tab @click="clearPreview(); updateComponentKey()" href="#generateTab">Generate</v-tab>
      <v-tab @click="clearPreview(); updateComponentKey()" href="#archiveTab">Archive</v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item :key="'generateTab'" :value="'generateTab'">
        <banner-generate-form :key="componentKey"></banner-generate-form>
      </v-tab-item>

      <v-tab-item :key="'archiveTab'" :value="'archiveTab'">
        <banner-archive></banner-archive>
      </v-tab-item>
    </v-tabs-items>
  </authenticated>
</template>

<script>
import BannerArchive from '@/components/affiliate-tools/BannerArchive'
import BannerGenerateForm from '@/components/affiliate-tools/BannerGenerateForm'
import Authenticated from '@/views/layouts/Authenticated'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
const { mapFields } = createHelpers({
  getterType: 'affiliateTools/getField',
  mutationType: 'affiliateTools/updateField',
})

export default {
  name: 'AffiliateTools',
  components: { Authenticated, BannerGenerateForm, BannerArchive },
  methods: {
    ...mapActions('affiliateTools', ['clearPreview']),
    ...mapMutations('affiliateTools', ['updateComponentKey'])
  },
  computed: {
    ...mapGetters('affiliateTools', ['componentKey']),
    ...mapFields(['activeTab']),
  }
}
</script>

<style scoped>
  .v-application--is-ltr .v-tabs-bar.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tabs-slider-wrapper + .v-tab {
    margin-left: 0;
  }
</style>